<template>
    <div style="background-color: rgba(0, 0, 0, 0.2)">
        <!--<ModalHeader title="회원가입"></ModalHeader>-->
        <div style="display: flex; justify-content: space-between; font-weight: 700; background-color: #fff; padding: 16px 20px; padding-bottom: 0">
            <div @click="() => {
                $GlobalStore.closeLastModal();
            }
            " style="color: #808080; padding-bottom: 16px; padding-right: 30px">
                닫기
            </div>
            <!-- <div @click="checkMemberInfo">다음</div> -->
        </div>
        <div style="overflow: auto; flex: 1; background-color: white; padding: 16px 20px; padding-top: 0">
            <div style="text-align: center; margin: 40px 0">
                <div v-if="isWriteDefaultInfo" style="font-weight: 700; font-size: 32px; line-height: 46px">계정 만들기</div>
                <div v-else style="font-weight: 700; font-size: 32px; line-height: 46px">계정 완성하기</div>
                <div style="font-weight: 500; line-height: 24px">등록할 회원정보를 5개만 입력해주세요</div>
            </div>
            <div style="margin-bottom: 20px">
                <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px">이름</div>
                <input v-model="name" placeholder="이름을 입력하세요" class="common_box" style="outline: none; width: 100%; border: none" />
                <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #606060; margin-top: 4px">정확한 이름을 입력해주세요.</div>
            </div>
            <div @click="setDateSelector" style="margin-bottom: 20px">
                <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px">생년월일</div>
                <div v-if="birth === ''" class="common_box" style="line-height: 24px; color: #bbbbbb; font-weight: 500">날짜를 선택해주세요</div>
                <div v-else class="common_box" style="line-height: 24px; font-weight: 500">{{ birth }}</div>
                <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #606060; margin-top: 4px">정확한 이름을 입력해주세요.</div>
            </div>
            <div style="margin-bottom: 20px">
                <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px">성별</div>
                <div @click="showPopMenu" class="common_box" style="position: relative; line-height: 24px; color: #bbbbbb; font-weight: 500; width: 77px; display: flex; align-items: center; gap: 12px; justify-content: space-between">
                    <div :style="{ color: sex === '' ? '' : '#210f03' }" style="font-size: 14px">{{ sex === "" ? "선택" : sex }}</div>
                    <img style="width: 10px; transform: rotate(90deg)" :src="require('@/assets/img/arrow_tick.png')" alt="" />
                    <MemberTalkPopMenuOption v-if="isShowPopMenu" :right="-173" :top="43" v-bind="popMenuOptions"></MemberTalkPopMenuOption>
                </div>
                <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #606060; margin-top: 4px">포지션 찾기 결과 등을 제공하기 위해 사용됩니다.</div>
            </div>
            <div style="margin-bottom: 20px">
                <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px">활동지역</div>
                <div class="common_box">
                    <div style="">
                        <NewPlaceSearchSelector :placeInfo="placeInfo" :resetInfo="resetInfo" :detect-select="detectPlaceSelect" style="flex:1; "></NewPlaceSearchSelector>
                    </div>
                </div>
                <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #606060; margin-top: 4px">회원님의 위치를 기반한 다양한 데이터 제공에 사용됩니다.</div>
            </div>
            <div style="margin-bottom: 20px">
                <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px">전화번호</div>
                <div :style="{ borderBottom: isSendAuthNumber ? '1px solid #ebebeb' : '' }">
                    <input v-model="phone" ref="phoneInput" type="tel" placeholder="휴대폰 번호 입력" class="common_box" :class="isSendAuthNumber ? 'none_radius' : ''" style="outline: none; width: 100%; border: none" />
                </div>
                <div v-if="isSendAuthNumber && !isAuthNumberChecked" style="border-bottom: 1px solid #ebebeb; position:relative;">
                    <input v-model="authNumber" type="tel" placeholder="인증 번호를 입력하세요" class="common_box" style="outline: none; border-radius: 0; width: 100%; border: none" maxlength="6" />
                    <div class="confirm_btn" style="" :class="[isSendAuthNumber && !isAuthNumberChecked && authNumber.length === 6 ? 'active' : '']" @click="checkAuthNumber">확인</div>
                </div>
                <div v-if="isSendAuthNumber" style="border-top-left-radius: 0; border-top-right-radius: 0" class="common_box">
                    <div style="display: flex; justify-content: space-between">
                        <div style="font-size: 12px; font-weight: 500; line-height: 20px; color: #808080">{{ isAuthNumberChecked ? "인증완료" : "인증번호가 오지 않았나요?" }}</div>
                        <div @click="sendAuthNumber(true)" v-if="!isAuthNumberChecked" style="font-size: 12px; font-weight: 500; line-height: 20px; color: var(--color-main)">인증번호 다시 받기</div>
                    </div>
                </div>
                <div v-if="!isSendAuthNumber" @click="sendAuthNumber" :class="phone.length !== 0 ? 'active_btn' : 'unactive_btn'">인증번호 보내기</div>
                <!--<div v-else-if="isSendAuthNumber && !isAuthNumberChecked" @click="checkAuthNumber" :class="authNumber.length !== 0 ? 'active_btn' : 'unactive_btn'">확인</div>-->
            </div>
        </div>
        <DateSelectorPopupVer2 :is-show-date-selector="isShowDateSelector" :hide="() => { isShowDateSelector = false; }" :complete-action="setBirthDate"></DateSelectorPopupVer2>
        <div style="z-index: 100;">
            <CommonPopupFrame :isOpen="isShowAgreePopup" :closeCompleteAction="closeAgreePopup" :changeHeight="50" :changeBottom="0">
                <div style="padding: 20px 16px">
                    <div style="display: flex; justify-content: space-between; font-weight: 700">
                        <div @click="closeAgreePopup" style="color: #808080; padding-bottom: 12px;">닫기</div>
                        <div v-if="isWriteDefaultInfo" @click="submit" style="color: var(--color-main); padding-bottom: 12px;">계정 만들기</div>
                        <div v-else @click="completeId" style="color: var(--color-main); padding-bottom: 12px;">계정 완성하기</div>
                    </div>

                    <div style="margin-top: 12px;">
                        <div style="font-size: 14px; font-weight: 500; line-height: 24px; margin-bottom: 4px">서비스 이용 동의</div>
                        <div class="common_box">
                            <div style="border-bottom: 1px solid #ebebeb; padding-bottom: 8px;" class="agree_check_wrap" @click="toggleCheck(1)">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[1]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content"><span style="color: var(--color-main);">이용약관, 개인정보 수집 및 이용</span>에 동의합니다.</div>
                            </div>
                            <div style="border-bottom: 1px solid #ebebeb; padding: 8px 0px;" class="agree_check_wrap" @click="toggleCheck(2)">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[2]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">위치기반 서비스 이용약관에 대해 동의합니다.</div>
                            </div>
                            <div style="border-bottom: 1px solid #ebebeb; padding: 8px 0px;" class="agree_check_wrap" @click="toggleCheck(3)">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[3]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">마케팅 메시지 수신을 원합니다.</div>
                            </div>
                            <div v-if="register_type == MEMBER_TYPE.COACH" style="border-bottom: 1px solid #ebebeb; padding: 8px 0px;" class="agree_check_wrap" @click="toggleCheck(4)">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[4]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">플랫폼 이용약관에 동의합니다.</div>
                            </div>
                            <div style="padding-top: 8px" class="agree_check_wrap" @click="checkAll">
                                <div class="">
                                    <img style="width: 13px;" v-if="agree[1] && agree[2] && agree[3] && agree[4]" :src="require('@/assets/img/schedule_check_on.png')" />
                                    <img style="width: 13px;" v-else :src="require('@/assets/img/schedule_check_off.png')" />
                                </div>
                                <div class="agree_content">전체동의</div>
                            </div>
                        </div>
                    </div>
                </div>
            </CommonPopupFrame>
        </div>
        <div style="background-color: #fff; height: 92px; padding: 0px 20px; display: flex; gap: 20px;">
            <div @click="() => { $GlobalStore.closeLastModal() }" style="background-color: #ededed; font-weight: 500; height: 40px; font-size: 14px; margin-top: 12px; text-align: center; line-height: 40px; border-radius: 12px; flex-basis: 102px;">이전</div>
            <div @click="checkMemberInfo" :class="isWriteComplete ? 'active' : 'unactive'" style="height: 40px; font-size: 14px; font-weight: 500; margin-top: 12px; text-align: center; line-height: 40px; border-radius: 12px; flex: 1">다음</div>
        </div>
        <div style="z-index: 110;">
            <PrivacyPolicy v-if="register_type == MEMBER_TYPE.USER" :isShowPrivacyPolicy="isShowPrivacyPolicy" :closePrivacyPolicy="closePrivacyPolicy"></PrivacyPolicy>
            <TempCoachAgreement v-if="register_type == MEMBER_TYPE.COACH" :is-open="isShowCoachPolicy" :close-action="() => { isShowCoachPolicy = false }" />
        </div>
    </div>
</template>

<script>
import DateSelectorPopupVer2 from "../common/DateSelectorPopupVer2";
import MemberTalkPopMenuOption from "../common/MemberTalkPopMenuOption";
import NewPlaceSearchSelector from "@/components/common/NewPlaceSearchSelector";
import CommonPopupFrame from "./my/CommonPopupFrame";
// import RegionSearchSelectorVer2 from '../common/RegionSearchSelectorVer2';
import ResponseCode from "../../ResponseCode";
import { MEMBER_TYPE } from "../../Constants";
import PrivacyPolicy from '@/components/modal/PrivacyPolicy'
import TempCoachAgreement from "../common/TempCoachAgreement";

export default {
    name: "MemberRegistStepTwo",
    components: {
        TempCoachAgreement,
        DateSelectorPopupVer2,
        MemberTalkPopMenuOption,
        CommonPopupFrame,
        // RegionSearchSelectorVer2,
        NewPlaceSearchSelector,
        PrivacyPolicy
    },
    mounted() {
        this.$Util.setPhoneFormatter(this.$refs.phoneInput);
    },
    props: {
        id: {
            type: String,
            default: "",
        },
        password: {
            type: String,
            default: "",
        },
        isWriteDefaultInfo: {
            type: Boolean,
            default: true
        },
        register_type: {
            type: Number,
            default: MEMBER_TYPE.USER
        },
        isFromKaKaoRegist: {
            type: Boolean,
            default: false,
        },
        mode: {
            type: String,
            default: ''
        },
        isLanding: {
            type: Boolean,
            default: false
        }

    },
    computed: {
        isWriteComplete() {
            if (!this.name) {
                return false;
            }

            if (!this.$Util.checkName(this.name)) {
                return false;
            }

            if (this.birth === '') {
                return false;
            }

            if (this.sex === '') {
                return false;
            }

            if (Object.keys(this.placeInfo).length === 0) {
                return false;
            }

            if (!this.isAuthNumberChecked) {
                return false;
            }

            return true
        }
    },
    data() {
        return {
            MEMBER_TYPE: MEMBER_TYPE,
            name: "",
            phone: "",
            isSendAuthNumber: false,
            isAuthNumberChecked: false,
            authNumber: "",
            agree: {
                0: false,
                1: false,
                2: false,
                3: false,
                4: false,
            },
            sex: "",
            birth: "",
            password_mode: "password",
            is_regist_active: false,
            regionInfo: {},
            isShowDateSelector: false,
            isShowPopMenu: false,
            isModify: false,
            isShowAgreePopup: false,
            region_name: '',
            isShowPrivacyPolicy: false,
            isShowCoachPolicy: false,
            placeInfo: {},
        };
    },
    methods: {
        detectPlaceSelect(placeInfo) {
            this.placeInfo = placeInfo
        },
        resetInfo() {
            this.placeInfo = {}
        },
        closePrivacyPolicy() {
            this.isShowPrivacyPolicy = false
        },
        submit() {
            if (this.isFromKaKaoRegist) {
                this.registKaKao();
            } else {
                this.regist();
            }
        },
        async completeId() {
            const formData = new FormData()
            formData.append('name', this.name);
            formData.append('birthday', this.birth.replaceAll('. ', '-'));
            formData.append('sex', this.sex);
            formData.append('authNumber', this.authNumber);
            formData.append('region_name', this.region_name);
            formData.append('phone', this.phone);

            const res = await this.$Axios.post('/api/profile/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.$GlobalStore.closeModalAll()
                await this.$Util.checkAfterLogin(true);
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
                if (res.data.msg === '이미 회원가입된 전화번호입니다.') {
                    this.isSendAuthNumber = false;
                    this.isAuthNumberChecked = false;
                    this.authNumber = ""
                }
            }


        },
        closeAgreePopup() {
            this.isShowAgreePopup = false;
        },
        async sendAuthNumber(isAgain) {
            if (!this.phone && this.phone.length !== 13) {
                this.$GlobalStore.showAlert("휴대폰번호를 입력해주세요.");
                return;
            }

            const parameters = {};
            parameters.phone = this.phone;
            parameters.duple = "0";

            const res = await this.$Axios.post("/api/auth/number", parameters);
            if (res.data.code === 0) {
                this.isSendAuthNumber = true;
                if (isAgain === true) {
                    alert("인증 번호를 다시 전송했습니다. 잠시만 기다려주세요");
                }
            } else {
                alert(res.data.msg);
            }
        },
        detectRegionSelect(region) {
            this.region_name = region.sido + ' ' + region.sigungu + ' ' + region.dong + (region.ri ? ' ' + region.ri : '');
            this.regionInfo = region;
        },
        showPopMenu() {
            this.isShowPopMenu = true;
            this.popMenuOptions = {
                labelAndAction: [
                    {
                        label: "남자",
                        action: async () => {
                            this.sex = "남자";
                            this.isShowPopMenu = false;
                        },
                        fontColor: "#210f03",
                    },
                    {
                        label: "여자",
                        action: () => {
                            this.sex = "여자";
                            this.isShowPopMenu = false;
                        },
                        fontColor: "#210f03",
                    },
                ],
                closeAction: () => {
                    this.isShowPopMenu = false;
                },
            };
        },
        setDateSelector() {
            this.isShowDateSelector = true;
        },
        setBirthDate(date) {
            this.birth = date.replaceAll('-', '. ');
        },
        test() {
            this.$GlobalStore.addModal("MakeJoinOrScheduleTwo");
        },
        togglePasswordMode() {
            if (this.password_mode === "password") {
                this.password_mode = "text";
            } else {
                this.password_mode = "password";
            }
        },
        toggleCheck(index) {
            if (index === 1 && !this.agree[1]) {
                if (this.register_type == MEMBER_TYPE.USER) {
                    this.isShowPrivacyPolicy = true
                } else if (this.register_type == MEMBER_TYPE.COACH) {
                    this.isShowCoachPolicy = true
                }
            }
            this.agree[index] = !this.agree[index];
        },
        checkAll() {
            const agreeCnt = Object.keys(this.agree).length;
            let flag = true;
            if (this.agree[0]) flag = false;

            if (flag) {
                if (this.register_type == MEMBER_TYPE.USER) {
                    this.isShowPrivacyPolicy = true
                } else if (this.register_type == MEMBER_TYPE.COACH) {
                    this.isShowCoachPolicy = true
                }
            }

            for (let i = 0; i < agreeCnt; i++) {
                this.agree[i] = flag;
            }
        },
        async checkAuthNumber() {
            if (!this.authNumber) {
                alert("인증번호를 입력해주세요.");
                return;
            }

            if (!this.phone) {
                alert("휴대폰번호를 입력해주세요.");
                return;
            }

            const parameters = {};
            parameters.phone = this.phone;
            parameters.authNumber = this.authNumber;

            const res = await this.$Axios.post("/api/auth/check", parameters);
            if (res.data.code === 0) {
                alert("인증되었습니다.");
                this.isAuthNumberChecked = true;
            } else {
                alert(res.data.msg);
                return;
            }
        },
        checkMemberInfo() {
            if (!this.name) {
                this.$GlobalStore.showAlert('이름을 입력해주세요.');
                return;
            }

            if (!this.$Util.checkName(this.name)) {
                this.$GlobalStore.showAlert('이름은 한글만 가능합니다.');
                return;
            }

            if (this.birth === '') {
                this.$GlobalStore.showAlert('생년월일을 입력해주세요.');
                return;
            }

            if (this.sex === '') {
                alert('성별을 선택해주세요.');
                return;
            }

            if (Object.keys(this.placeInfo).length === 0) {
                this.$GlobalStore.showAlert('활동지역을 선택해주세요.');
                return;
            }

            if (!this.isAuthNumberChecked) {
                alert('인증번호를 확인해주세요.');
                return;
            }

            if (this.isWriteDefaultInfo) {
                this.isShowAgreePopup = true
            } else {
                this.completeId()
            }
        },
        async regist() {

            if (!this.agree[1]) {
                this.$GlobalStore.showAlert('이용약관, 개인정보 수집 및 이용에 동의해주세요.');
                return;
            }

            if (!this.agree[2]) {
                this.$GlobalStore.showAlert('위치기반 서비스 이용약관에 대해 동의해주세요.');
                return;
            }

            const parameters = {};
            parameters.id = this.id;
            parameters.password1 = this.password;
            parameters.name = this.name;
            parameters.birthday = this.birth.replaceAll('. ', '-');
            parameters.sex = this.sex === '남자' ? '남' : '여'
            parameters.authNumber = this.authNumber;
            parameters.place_id = this.placeInfo.id
            parameters.place_gps_latitude = this.placeInfo.gps_latitude
            parameters.place_gps_longitude = this.placeInfo.gps_longitude
            parameters.place_name = this.placeInfo.name
            parameters.place_address = this.placeInfo.address
            // parameters.region_name = this.region_name;
            parameters.phone = this.phone;
            parameters.register_type = this.register_type;

            const device = this.$cookies.get("device");
            if (device === "android" || device === "ios") {
                parameters.pushToken = await window.pushCustomManager.getPushToken();
                parameters.uuid = await window.pushCustomManager.getUuid();
            }

            parameters.marketingAgree = this.agree[3] ? "1" : "0";

            const res = await this.$Axios.post("/api/member/regist", parameters);
            if (res.data.code === 0) {
                if (res.data.is_already_regi_coach) this.$GlobalStore.showAlert("기존에 등록된 코치정보가 있습니다.\n해당 코치정보와 연결합니다.");
                sessionStorage.setItem('IS_LANDING', this.isLanding);
                this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                this.$GlobalStore.closeLastModal(true);
                this.$GlobalStore.closeLastModal(true);
                this.$GlobalStore.closeLastModal(true);

                await this.$Util.checkAfterLogin(true);
                if (this.register_type == MEMBER_TYPE.COACH) {
                    this.$GlobalStore.addModal('CoachRegisterExplanation', { step: 0, transitionName: 'bottom' })
                }
            } else {
                alert(res.data.msg);
                if (res.data.msg === '이미 회원가입된 전화번호입니다.') {
                    this.isSendAuthNumber = false;
                    this.isAuthNumberChecked = false;
                    this.authNumber = ""
                }
            }
        },
        // async regist() {
        //     // this.$GlobalStore.setLoginInfo(this.$GlobalStore.loginInfo());
        //     this.$GlobalStore.closeLastModal(true);
        //     this.$GlobalStore.closeLastModal(true);
        //     this.$GlobalStore.closeLastModal(true);
        //     this.$Util.checkAfterLogin(true);
        // },
        async registKaKao() {
            if (!this.agree[1]) {
                this.$GlobalStore.showAlert('이용약관, 개인정보 수집 및 이용에 동의해주세요.');
                return;
            }

            if (!this.agree[2]) {
                this.$GlobalStore.showAlert('위치기반 서비스 이용약관에 대해 동의해주세요.');
                return;
            }

            if (this.register_type == MEMBER_TYPE.COACH && !this.agree[4]) {
                this.$GlobalStore.showAlert('플랫폼 이용 약관에 동의합니다.');
                return;
            }

            const parameters = {};
            parameters.id = this.id;
            parameters.name = this.name;
            parameters.birthday = this.birth.replaceAll('. ', '-');
            parameters.sex = this.sex === '남자' ? '남' : '여'
            parameters.authNumber = this.authNumber;
            parameters.place_id = this.placeInfo.id
            parameters.place_gps_latitude = this.placeInfo.gps_latitude
            parameters.place_gps_longitude = this.placeInfo.gps_longitude
            parameters.place_name = this.placeInfo.name
            parameters.place_address = this.placeInfo.address
            // parameters.region_name = this.region_name;
            parameters.phone = this.phone;
            parameters.register_type = this.register_type;
            parameters.mode = this.mode;

            const device = this.$cookies.get("device");
            if (device === "android" || device === "ios") {
                parameters.pushToken = await window.pushCustomManager.getPushToken();
                parameters.uuid = await window.pushCustomManager.getUuid();
            }

            parameters.marketingAgree = this.agree[3] ? "1" : "0";

            try {
                const res = await this.$Axios.post('/regist/kakao', parameters);
                if (res.data.code === 0) {
                    localStorage.removeItem('marketing_agree');
                    this.$GlobalStore.setLoginInfo(res.data.loginInfo);
                    this.$GlobalStore.closeLastModal(true);
                    this.$GlobalStore.closeLastModal(true);

                    await this.$Util.checkAfterLogin(true);
                } else {
                    alert(res.data.msg);
                }
            } catch (e) {
                alert(JSON.stringify(e));
            }
        },
    },
    created() {
        this.registKaKao = this.$Once(this.registKaKao);
        this.regist = this.$Once(this.regist);
        this.sendAuthNumber = this.$Once(this.sendAuthNumber);

        if (this.register_type == MEMBER_TYPE.USER) {
            this.agree[4] = true;
        }

        const marketing_agree = localStorage.getItem("marketing_agree") ?? "";
        if (marketing_agree == "1") {
            this.agree[3] = true;
        }
    },
};
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
}

.active {
    background-color: var(--color-main);
    color: #fff;
}

.unactive {
    background-color: #f5f5f5;
    color: #d9d9d9;
}

.label_wrap {
    padding: 0px 15px;
    margin-top: 20px;
}

.agree_check_wrap {
    display: flex;
    align-items: center;
    gap: 20px;
}

.agree_content {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
}

.input_explain {
    color: #808080;
    font-size: 10px;
    margin-top: 12px;
    margin-bottom: 20px;
}

.check_border {
    display: inline-block;
    width: 14px;
    height: 14px;
    border: 1px solid #d9d9d9;
    position: relative;
    border-radius: 3px;
}

.check_img {
    width: 13px;
    height: 10px;
    position: absolute;
    top: 0px;
}

.regist_btn {
    margin-top: 40px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #d9d9d9;
    color: white;
    font-weight: 500;
    border-radius: 5px;
    text-align: center;
}

.regist_btn.active {
    background-color: #ff6100;
}

.common_box {
    padding: 12px;
    background-color: #f5f5f5;
    border-radius: 12px;
}

input::placeholder {
    font-weight: 500;
    font-size: 16px;
    color: #bbbbbb;
}

.active_btn {
    border-radius: 12px;
    height: 44px;
    line-height: 44px;
    background-color: var(--color-main);
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    margin-top: 20px;
}

.unactive_btn {
    border-radius: 12px;
    height: 44px;
    line-height: 44px;
    background-color: #f5f5f5;
    color: #d9d9d9;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    margin-top: 20px;
}

.none_radius {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.confirm_btn {
    background-color: #D9D9D9;
    position: absolute;
    top: 10px;
    right: 10px;
    width: 100px;
    font-size: 12px;
    font-weight: 500;
    color: white;
    height: 30px;
    border-radius: 15px;
    display: grid;
    place-items: center;
}

.confirm_btn.active {
    background-color: black;
}
</style>
